var render = function render(){var _vm=this,_c=_vm._self._c;return _c('icon-button',{staticClass:"ar-icon ar-icon__xs ar-icon--no-border",attrs:{"name":"save"},nativeOn:{"click":function($event){return _vm.upload.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }